import { motion } from 'framer-motion';
import React from 'react';

export const Page = React.memo(({ children, delay = 0 }) => (
  <motion.div
    initial={{ opacity: 0, y: 12 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -12 }}
    transition={{ duration: 0.45, ease: 'easeOut', delay }}
    style={{ willChange: 'opacity, transform' }}
  >
    {children}
  </motion.div>
));

Page.displayName = 'Page';

export const Reveal = React.memo(({ children, delay = 0, y = 16 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.5, ease: 'easeOut', delay }}
  >
    {children}
  </motion.div>
));

Reveal.displayName = 'Reveal';

export const Stagger = React.memo(({ children, stagger = 0.08, delay = 0 }) => (
  <motion.div
    variants={{
      show: {
        transition: { staggerChildren: stagger, delayChildren: delay },
      },
    }}
    initial='hidden'
    whileInView='show'
    viewport={{ once: true, amount: 0.2 }}
  >
    {children}
  </motion.div>
));

Stagger.displayName = 'Stagger';

export const Item = React.memo(({ children }) => (
  <motion.div
    variants={{ hidden: { opacity: 0, y: 10 }, show: { opacity: 1, y: 0 } }}
    transition={{ duration: 0.35 }}
  >
    {children}
  </motion.div>
));

Item.displayName = 'Item';
